/**
 * Creates a debounced function that delays invoking the provided callback
 * until after the specified wait time has elapsed since the last time it was invoked.
 *
 * @param {Function} callback - The function to debounce
 * @param {number} wait - The number of milliseconds to delay
 * @return {Function} The debounced function
 */
export const debounce = (callback, wait) => {
  /** @type {number | undefined} */
  let timeoutId;
  return (/** @type {any[]} */ ...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback(...args);
    }, wait);
  };
};
